'use strict';

function setFocusOnPasswordField() {
    var $form = $('form[id$="_loginintercept"]');
    var email = $form.find('.js-input-email').val();

    if (email) {
        $form.find('.js-input-password').focus();
    }
}

function initializeDom() {
    setFocusOnPasswordField();
}

exports.init = function () {
    initializeDom();
    // --- keyboard-only focus ---
    (function () {
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Tab' || e.keyCode === 9) {
                document.body.classList.add('keyboard-mode');
            }
        });

        document.addEventListener('mousedown', function () {
            document.body.classList.remove('keyboard-mode');
        });

        document.addEventListener('touchstart', function () {
            document.body.classList.remove('keyboard-mode');
        });
    })();
};
